import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { PropertyFeatureTemplateService } from '../property-feature-template.service';
import { PropertyFeatureTemplate } from '../property-feature-template';

@Component({
    selector: 'app-property-feature-template',
    templateUrl: './property-feature-template.component.html',
    styleUrls: ['./property-feature-template.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class PropertyFeatureTemplateComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private propertyFeatureTemplateService: PropertyFeatureTemplateService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.propertyFeatureTemplate = data.propertyFeatureTemplate,
			this.statuses = propertyFeatureTemplateService.statuses;
	}

	@Input() propertyFeatureTemplate: PropertyFeatureTemplate;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	propertyFeatureTemplateId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'propertyFeatureTemplateId': [],
		'templateName': [],
		'locationId': [],
		'adrDistrict': [],
		'adrCity': [],
		'adrRegion': [],
		'developmentId': [],
		'bedrooms': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole propertyFeatureTemplate object
		if (this.propertyFeatureTemplate) {
			this.propertyFeatureTemplateId = this.propertyFeatureTemplate.propertyFeatureTemplateId;
			this.fixDates();
			this.form1.patchValue(this.propertyFeatureTemplate);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.propertyFeatureTemplateId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.propertyFeatureTemplateService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.propertyFeatureTemplate = res.data.propertyFeatureTemplate;
						this.doAdd.emit(this.propertyFeatureTemplate);
					},
					(err: any) => {
						console.log('propertyFeatureTemplate-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('propertyFeatureTemplate: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.propertyFeatureTemplateService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.propertyFeatureTemplate = res.data.propertyFeatureTemplate;
						this.doUpdate.emit(this.propertyFeatureTemplate);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.propertyFeatureTemplateService.delete(this.propertyFeatureTemplate.propertyFeatureTemplateId)
				.subscribe(
					(res: any) => {
						console.log('propertyFeatureTemplate-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.propertyFeatureTemplate);
					},
					(err: any) => {
						console.log('propertyFeatureTemplate-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			propertyFeatureTemplateId: [this.propertyFeatureTemplateId],
			templateName: [],
			locationId: [],
			adrDistrict: [],
			adrCity: [],
			adrRegion: [],
			developmentId: [],
			bedrooms: [],
			});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.propertyFeatureTemplate.propertyFeatureTemplateDate = moment(this.propertyFeatureTemplate.propertyFeatureTemplateDate).toDate();
	}
}
